import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GhostwriterViewerApplicationsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type GhostwriterViewerApplicationsQuery = { __typename?: 'Query', ghostwriter: { __typename?: 'GhostwriterQueries', viewer: { __typename?: 'GhostwriterViewer', applications?: { __typename?: 'GhostwriterApplicationsConnection', edges: Array<{ __typename?: 'GhostwriterApplicationEdge', node: { __typename?: 'GhostwriterApplication', id: string, applicationStatus: Types.GhostwriterApplicationStatus, applicationNotes?: string | null, externalApplicationId?: string | null, createdAt: string, updatedAt: string, job: { __typename?: 'GhostwriterJob', id: string, parsingStatus: Types.GhostwriterParsingStatus, job: { __typename?: 'Job', key: string, title: string, sourceEmployerName: string, description: { __typename?: 'JobDescription', text: string, html: string }, location: { __typename?: 'JobLocation', formatted: { __typename?: 'FormattedJobLocation', long: string } }, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null } | null } }, formFieldGroups: Array<{ __typename?: 'GhostwriterFormFieldGroup', id: string, groupLabel?: string | null, groupType?: string | null, isCollapsed: boolean, formFields: Array<{ __typename?: 'GhostwriterFormField', id: string, fieldName?: string | null, fieldType: Types.GhostwriterFormFieldType, classification?: string | null, autocompleteType?: Types.GhostwriterAutocompleteType | null, label?: string | null, description?: string | null, placeholder?: string | null, value?: string | null, required: boolean, disabled: boolean, readonly: boolean, confirmsFieldName?: string | null, validationInputType?: Types.GhostwriterValidationInputType | null, options?: Array<{ __typename?: 'GhostwriterFieldOption', value: string, label: string }> | null, condition?: { __typename?: 'GhostwriterFieldCondition', fieldName: string, value: string, operator: Types.GhostwriterConditionOperator } | null }>, nestedFormFieldGroup?: { __typename?: 'GhostwriterFormFieldGroup', id: string, groupLabel?: string | null, groupType?: string | null, isCollapsed: boolean, formFields: Array<{ __typename?: 'GhostwriterFormField', id: string, fieldName?: string | null, fieldType: Types.GhostwriterFormFieldType, classification?: string | null, autocompleteType?: Types.GhostwriterAutocompleteType | null, label?: string | null, description?: string | null, placeholder?: string | null, value?: string | null, required: boolean, disabled: boolean, readonly: boolean, confirmsFieldName?: string | null, options?: Array<{ __typename?: 'GhostwriterFieldOption', value: string, label: string }> | null, condition?: { __typename?: 'GhostwriterFieldCondition', fieldName: string, value: string, operator: Types.GhostwriterConditionOperator } | null }> } | null }>, currentResponseSet?: { __typename?: 'GhostwriterResponseSet', id: string, isUserApproved: boolean, createdAt: string, responseGroups: Array<{ __typename?: 'GhostwriterResponseGroup', id: string, name?: string | null, canCreateNewResponseGroup: boolean, displayOrder?: number | null, fieldResponses: Array<{ __typename?: 'GhostwriterFieldResponse', id: string, responseValue?: string | null, selectedOptions: Array<string>, validationStatus: Types.GhostwriterValidationStatus, source: Types.GhostwriterResponseSource, formField: { __typename?: 'GhostwriterFormField', id: string } }> }> } | null } }> } | null } } };


export const GhostwriterViewerApplicationsDocument = gql`
    query GhostwriterViewerApplications($first: Int!) {
  ghostwriter {
    viewer {
      applications(first: $first) {
        edges {
          node {
            id
            applicationStatus
            applicationNotes
            externalApplicationId
            createdAt
            updatedAt
            job {
              id
              parsingStatus
              job {
                key
                title
                description {
                  text
                  html
                }
                location {
                  formatted {
                    long
                  }
                }
                sourceEmployerName
                compensation {
                  formattedText
                }
              }
            }
            formFieldGroups {
              id
              groupLabel
              groupType
              isCollapsed
              formFields {
                id
                fieldName
                fieldType
                classification
                autocompleteType
                label
                description
                placeholder
                value
                required
                disabled
                readonly
                confirmsFieldName
                options {
                  value
                  label
                }
                validationInputType
                condition {
                  fieldName
                  value
                  operator
                }
              }
              nestedFormFieldGroup {
                id
                groupLabel
                groupType
                isCollapsed
                formFields {
                  id
                  fieldName
                  fieldType
                  classification
                  autocompleteType
                  label
                  description
                  placeholder
                  value
                  required
                  disabled
                  readonly
                  confirmsFieldName
                  options {
                    value
                    label
                  }
                  condition {
                    fieldName
                    value
                    operator
                  }
                }
              }
            }
            currentResponseSet {
              id
              isUserApproved
              createdAt
              responseGroups {
                id
                name
                canCreateNewResponseGroup
                displayOrder
                fieldResponses {
                  id
                  formField {
                    id
                  }
                  responseValue
                  selectedOptions
                  validationStatus
                  source
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGhostwriterViewerApplicationsQuery__
 *
 * To run a query within a React component, call `useGhostwriterViewerApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhostwriterViewerApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhostwriterViewerApplicationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGhostwriterViewerApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables> & ({ variables: GhostwriterViewerApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>(GhostwriterViewerApplicationsDocument, options);
      }
export function useGhostwriterViewerApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>(GhostwriterViewerApplicationsDocument, options);
        }
export function useGhostwriterViewerApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>(GhostwriterViewerApplicationsDocument, options);
        }
export type GhostwriterViewerApplicationsQueryHookResult = ReturnType<typeof useGhostwriterViewerApplicationsQuery>;
export type GhostwriterViewerApplicationsLazyQueryHookResult = ReturnType<typeof useGhostwriterViewerApplicationsLazyQuery>;
export type GhostwriterViewerApplicationsSuspenseQueryHookResult = ReturnType<typeof useGhostwriterViewerApplicationsSuspenseQuery>;
export type GhostwriterViewerApplicationsQueryResult = Apollo.QueryResult<GhostwriterViewerApplicationsQuery, GhostwriterViewerApplicationsQueryVariables>;